import { Box } from '@spark-web/box';
import { Inline } from '@spark-web/inline';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';

type EligibilityStepHeaderProps = {
  currentStep: number;
  totalSteps: number;
};

const STEP_LABELS: Record<number, string> = {
  1: 'Getting started',
  2: 'Installation address',
  3: 'Certificate of title',
  4: 'Taxable income',
  5: 'Verify income',
};

function EligibilityStepHeader({ currentStep, totalSteps }: EligibilityStepHeaderProps) {
  const fillPercent = (currentStep / totalSteps) * 100;
  const stepLabel = STEP_LABELS[currentStep] ?? 'Eligibility check';

  return (
    <Stack gap="medium" marginBottom={{ tablet: 'xxlarge' }}>
      <Inline gap="small" alignY="center">
        <Text weight="semibold" size="standard">
          {stepLabel}
        </Text>
        <Text size="standard" tone="muted">
          ({currentStep}/{totalSteps})
        </Text>
      </Inline>
      <Box display="flex" style={{ height: '3px', borderRadius: '2px', overflow: 'hidden' }}>
        <Box background="primary" style={{ width: `${fillPercent}%` }} />
        <Box background="surfaceMuted" flex={1} />
      </Box>
    </Stack>
  );
}

export default EligibilityStepHeader;
